module.exports = __webpack_public_path__ + "static/PlanA.Earth-1781584f8f62f51df609ea0f19e1e06d.jpg";